import React from 'react';
import { useQuery } from 'react-query';

import { getAllCommunitiesStats } from 'apis/CommunityAPI';
import { useAppSelector } from 'store/hook';

import OverviewAverages from './OverviewAverages';
import { OverviewStatsContext } from './OverviewStatsContext';

const OverviewStats = () => {
  const { currentUser } = useAppSelector((state) => state.auth);

  const { data } = useQuery({
    queryKey: ['overview', 'stats', currentUser],
    queryFn: () => getAllCommunitiesStats(),
    enabled: Boolean(currentUser && !currentUser.isSuperuser),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  });

  return (
    <OverviewStatsContext.Provider value={{ overviewStats: data }}>
      <OverviewAverages />
    </OverviewStatsContext.Provider>
  );
};

export default OverviewStats;
